<template>
  <div class="gallery-carusel-wrp">
    <div class="panorama-wrp">
      <iframe
        class="panorama-item"
        :src="baseUrl + items"
        height="100%"
        :style="{width: '100%'}"
        @load="loadTourHandler(items)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {ref} from 'vue';
import {useRuntimeConfig} from '#imports';

const props = defineProps<{
  items: any;
}>();

const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.vueAppBaseUrl;

const loadTourForStart = ref<{[key: string]: boolean}>({});
const loadTourHandler = (currentTour: string) => {
  loadTourForStart.value = {
    ...loadTourForStart.value,
    [currentTour]: true,
  };
};
</script>

<style lang="scss" scoped>
.gallery-carusel-wrp {
  display: flex;
  gap: 16px;
  .panorama-wrp {
    width: 100%;
    max-height: 700px;

    .panorama-item {
      height: 700px;
      border-radius: 8px;
      border: none;
      width: 100%;

      @media (max-width: 900px) {
        height: 400px;
      }

      @media (max-width: 720px) {
        height: 100%;
        min-height: 200px;
      }
    }
  }
}
</style>
